import Antd from 'ant-design-vue'
import { App } from 'vue'

export default function (app: App) {
  app.use(Antd)
}
